export default "__VITE_ASSET__o5sRW3iN__"